var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isRender)?_c('div',[_c('div',{ref:"contentRef",class:{ 'overflow-hidden': _setup.isAnimating },attrs:{"data-component":"CsCollapse"}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }